import React from "react";
import { AppInit } from "./components/AppInit";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/reset.css";
import store from "./appStatusManager/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ReactResizeDetector from "react-resize-detector";
import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES";
import "dayjs/locale/es";
import dayjs from "dayjs";
dayjs.locale("es");

const client = new QueryClient();

function App() {
  document.title =
    process.env.REACT_APP_PROJECT_NAME || "Microfront-Template-DT";

  const dev_mode = process.env.REACT_APP_DEV_MODE === "development";
  const onResize = (width, height) => {
    window.parent.postMessage(`resize:${height}`, "*");
  };

  return (
    <>
      <ReactResizeDetector handleHeight onResize={onResize} />
      <Provider store={store}>
        <QueryClientProvider client={client}>
          <ConfigProvider locale={esES}>
            <AppInit />
            {dev_mode ? (
              <ReactQueryDevtools
                initialIsOpen={false}
                panelPosition="top"
                position="top-left"
              />
            ) : null}
          </ConfigProvider>
        </QueryClientProvider>
      </Provider>
    </>
  );
}

export default App;
